<template>
  <div class="medias">
    <div class="media-play-box" v-if="medias.length > 0" @click="openInHeybox">
      <OutOpen
        :protocol="protocol"
        :page-identifier="'game/detail'"
        v-if="canUseDeepLink"
      ></OutOpen>
      <img :src="medias[active_index].thumbnail" alt="" />
      <div class="btn-media-play" v-if="medias[active_index].type == 'movie'">
        <div class="icon-play"></div>
      </div>
    </div>
    <div class="media-list-wrapper">
      <div class="media-list">
        <div
          class="media-item"
          :class="{ on: active_index === index }"
          :key="index"
          v-for="(media, index) in medias"
          @click="active_index = index"
        >
          <img :src="media.thumbnail" alt="" />
          <div class="btn-media-play" v-if="media.type == 'movie'">
            <div class="icon-play"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OutOpen from '_com/OutOpen';
export default {
  components: {
    OutOpen,
  },
  props: {
    medias: {
      type: Array,
      default: () => [],
    },
    protocol: {
      type: String,
      default: '',
    },
    canUseDeepLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active_index: 0,
    };
  },
  methods: {
    openInHeybox() {
      this.$emit('openInHeybox');
    },
  },
};
</script>

<style lang="less">
.medias {
  .media-list-wrapper {
    width: 100%;
    height: 44px;
    background-color: rgba(#14191e, 0.9);
    overflow: hidden;
    .media-list {
      width: 100%;
      height: 60px;
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      padding-top: 4px;
      .media-item {
        width: 64px;
        height: 36px;
        margin-left: 4px;
        border-radius: 1px;
        position: relative;
        display: inline-block;
        cursor: pointer;
        &.on {
          &:before,
          &:after {
            content: '';
            width: 100%;
            height: 100%;
            border: 1px solid #dadde0;
            position: absolute;
          }
          &:before {
            top: -1px;
            left: -1px;
            border-radius: 2px;
          }
          &:after {
            box-sizing: border-box;
            top: 0;
            left: 0;
          }
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .btn-media-play {
          width: 26px;
          height: 20px;
          .icon-play {
            border: 4px solid transparent;
            border-left: 6px solid rgba(255, 255, 255, 0.5);
            border-right-width: 0;
            margin-left: 1px;
          }
        }
      }
    }
  }
  .media-play-box {
    width: 100%;
    padding-top: 50.66667%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
    }
  }
  .btn-media-play {
    width: 50px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 2px;
    cursor: pointer;
    .icon-play {
      width: 0;
      height: 0;
      border: 9px solid transparent;
      border-left: 14px solid rgba(255, 255, 255, 0.5);
      border-right-width: 0;
      margin-left: 2px;
    }
  }
}
</style>
